import { useParams } from "react-router-dom";
import FilterComponent from "../components/FilterComponent";
import ItemCard from "../components/ItemCard";
import LocationDiv from "../components/LocationDiv";
import MenuPanel from "../components/MenuPanel";
import TitleDiv from "../components/TitleDiv";
import { Paper, Text, Container, Grid, Button, Image, Badge } from '@mantine/core';
import { useSelector, useDispatch } from "react-redux";
import "./HomePage.css";
import { useEffect, useMemo, useState } from "react";
import { getProducts } from "../Redux/CounterSlice";
import {
  fetchUserAccount,
  getPropertiesReducer,
  walletBalanceFetch,
} from "../Redux/properties/PropertiesSlice";

import {
  CURRENT_PURPOSE,
  WEBSITE_CONSTANTS,
  WEBSITE_FARM_TRADE,
  WEBSITE_REAL_ESTATE,
} from "../configs/website-config";
import RealEstateMediaCard from "../components/RealEstateItem";
import { HashConnect } from "hashconnect";
import SalePanel from "../components/SalePanel";
import { LoginModal } from "../components/LoginModal";
import MobileMenuPanel from "../components/MobileMenuPanel"; 
import MobileFooter from "../components/MobileFooter";
import MobileSecondFooter from "../components/MobileSecondFooter";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FormattedMessage, useIntl } from 'react-intl';

const backgroundImage =
  CURRENT_PURPOSE === WEBSITE_REAL_ESTATE
    ? "../assets/bg.jpeg"
    : "../assets/summer.png";

const style = {
  papaerStyle: {
    width: "100%",
    backgroundColor: '#F8F8FF', // Set the desired background color
    padding: '2px', // Add padding to create space between elements
    overflow: 'visible', // Changed from 'hidden' to 'visible'
    paddingBottom: '80px', // Space for bottom navigation
  },
  gridStyle: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center", // Adjusted to center align
  },
  dummBar: {
    color: "#333333",
    textAlign: "center",
    fontWeight: "bolder",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: '16px',
    width: '100%', // Ensures the bar takes full width
    boxSizing: 'border-box', // Includes padding in the width
  },
  addressBar: {
  },
  menuBar: {
    width: "100%",
    padding: '16px', // Add padding to create space between elements
    backgroundColor: '#F8F8FF', 
  },
  titleBar: {
    color: '#1a488f', // Set the title color
    fontSize: '1.5em', // Define the title font size
  },
  dummBar1: {
    color: "#ffffff",
    textAlign: "center",
    fontWeight: "bolder",
  },
  lineDiv: {
    color: "#ffffff",
    textAlign: "center",
    fontWeight: "bolder",
    marginTop: "2%",
  },
  Filter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px', // Add padding to create space between elements
  },
  items: {
    height: "auto",
    padding: '2px',
    width: '100%', // Increased from default
    marginTop: '10px',
    marginBottom: '10px',
  },
  whole: {
    minHeight: "100vh", // Added minimum height
    height: "100%",
    width: "100%",
    overflow: "auto", 
    display: "flex",
  },
};

const MobileMarketplace = () => {
  let { level } = useParams();
  const [filter, setFilter] = useState({ category: '', product: '' })
  const products = useSelector((state) => state.properties.data);

  // Debug logging
  useEffect(() => {
    console.log("Products data:", products);
  }, [products]);

  const productsFilter = useMemo(() => {
    return products.filter(e => {
      const productFilter = filter.category
        ? e?.product_name_id === filter.UPC
        : true;

      const upcFilter = filter.category
      ? e?.product_name_id === filter.UPC
      : true;

      return productFilter && upcFilter;
    });
  }, [products, filter]);

  const dispatch = useDispatch();
  const [salePanelModal, setSalePanelModal] = useState(false);
  const [saleSelected, setSaleSelected] = useState();

  useEffect(() => {
    if (saleSelected) console.log("saleSelected", saleSelected);
    setSalePanelModal(true);
  }, [saleSelected]);

  return (
    <>
        {saleSelected && (
          <SalePanel
            modal={salePanelModal}
            toggle={() => {
              setSalePanelModal(false);
              setSaleSelected(undefined);
            }}
            title={saleSelected?.title}
            value={saleSelected}
          >
            {" "}
          </SalePanel>
        )}
        <div className="whole" style={style.whole}>
        <Paper sx={style.papaerStyle} className="backgroundImage">
          <Grid container sx={style.gridStyle}>
            <Grid item sx={style.menuBar}>
              <MobileMenuPanel level={level}/>
            </Grid>
            <Grid item sx={style.dummBar}>
              <h2 style={{ 
                color: '#1a488f', 
                margin: '8px 0',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                textShadow: '0px 1px 2px rgba(0,0,0,0.1)'
              }}>
                {WEBSITE_CONSTANTS.QUOTE1}
              </h2>
            </Grid>
            {/* <Grid item sx={style.Filter}>
              <FilterComponent setFilter={setFilter} filter={filter} />
            </Grid> */}
            <Grid item sx={style.items}>
              <Items selectedSale={setSaleSelected} products={productsFilter}/>
            </Grid>
              <MobileSecondFooter />
              <MobileFooter />
          </Grid>
        </Paper>
        </div>
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white',
          padding: '8px 16px',
          boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
          zIndex: 1000,
          borderTop: '1px solid #eee',
          height: '60px',
          display: 'flex',
          alignItems: 'center'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            width: '100%'
          }}>
            <div style={{ 
              marginRight: '10px', 
              color: '#1a488f', 
              fontSize: '20px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}>
              🔍
            </div>
            <FilterComponent setFilter={setFilter} filter={filter} />
          </div>
        </div>
        <LoginModal />
        <ToastContainer
          style={{height: "30px", width: "250px",fontSize: "0.7em", position: "top-center"}}
          position="top-center"
          autoClose= {5000}
          hideProgressBar= {false}
          closeOnClick= {true}
          pauseOnHover= {true}
          draggable= {true}
          progress= {undefined}
          theme="light"
          />
    </>
  );
};

// Items component with the improved product cards
const Items = ({ selectedSale, products }) => {
  const dispatch = useDispatch();
  const [fetched, setFetched] = useState(false);
  const [imageUrls, setImageUrls] = useState({});

  // Debug logging
  useEffect(() => {
    console.log("Products:", products);
  }, [products]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      loadDetails();
    }
  }, [fetched]);

  const loadDetails = async () => {
    if (CURRENT_PURPOSE === WEBSITE_REAL_ESTATE) {
      dispatch(getPropertiesReducer());
    } else {
      dispatch(getProducts());
    }
  };

  const openSalePanel = (product) => {
    selectedSale(product);
  };

  // Load images
  useEffect(() => {
    const loadImages = async () => {
      const urls = {};
      for (const product of products) {
        if (product.publishId === 1) {
          const imageUrl = `https://vertoledgerstorage.blob.core.windows.net/sqldbledgerdigests/images/${product.productRefID}.png`;
          const defaultImage = `https://vertoledgerstorage.blob.core.windows.net/sqldbledgerdigests/images/${product.product_name_id}.jpg`; 
          
          try {
            const response = await fetch(imageUrl);
            urls[product.productRefID] = response.ok ? imageUrl : defaultImage;
          } catch (error) {
            urls[product.productRefID] = defaultImage;
          }
        }
      }
      setImageUrls(urls);
    };
    
    if (products && products.length > 0) {
      loadImages();
    }
  }, [products]);

  // Handle empty products list
  if (!products || products.length === 0) {
    return (
      <Container size="md">
        <Paper padding="md" shadow="xs" style={{ padding: '16px', textAlign: 'center' }}>
        <Text><FormattedMessage id="marketplace.noproduct" /></Text>
        </Paper>
      </Container>
    );
  }

  return (
    <Container size="md" style={{ width: '100%', maxWidth: 'none' }}>
      <Paper padding="md" shadow="xs" style={{ display: 'flex', flexDirection: 'column', padding: '16px' }}>
        {products
          .filter(product => product && product.publishId === 1)
          .map((product, index) => (
            <div key={index}>
              <div style={{ 
                display: 'flex', 
                marginBottom: '10px', 
                border: '1px solid #ccc', 
                borderRadius: '8px', 
                padding: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}>
                <div style={{ 
                  width: '30%', 
                  position: 'relative', 
                  overflow: 'hidden', 
                  backgroundColor: 'white',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <img
                    src={imageUrls[product.productRefID] || ''}
                    alt={product.productName}
                    style={{
                      width: '100%',
                      aspectRatio: '1',
                      objectFit: 'cover',
                      marginBottom: '10px'
                    }}
                  />
                  <Button
                    size="compact-md"
                    variant="filled"
                    color="blue"
                    onClick={() => openSalePanel(product)}
                    style={{ width: '100%', fontSize: '13px' }}
                  >
                    <FormattedMessage id="button.viewdetails" />
                  </Button>
                </div>
                <div style={{ width: '70%', padding: '0 8px 0 12px' }}>
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    height: '100%', 
                    justifyContent: 'space-between'
                  }}>
                    <div>
                      <Text weight={600} size="md" style={{ marginBottom: '4px' }}>
                        {product.productName}
                      </Text>
                      <Text weight={600} color="blue" size="md" style={{ marginBottom: '6px' }}>
                        {product.price}
                      </Text>
                      <Text size="sm">
                        <FormattedMessage id="product.location1" />{product.location}
                      </Text>
                      <Text size="sm">
                        <FormattedMessage id="product.deliverprd1" />{product.period}
                      </Text>
                    </div>
                    <div style={{ fontSize: 'calc(0.5em + 0.3vw)', color: '#666', marginTop: '6px' }}>
                      <Badge size="sm" color="gray" variant="outline">
                        {product.sku}
                      </Badge>
                      <Text size="xs" style={{ marginTop: '4px' }}>
                        <FormattedMessage id="product.quantity1" />{product.quantity}
                      </Text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </Paper>
    </Container>
  );
};

export default MobileMarketplace;